import { useState } from 'react'
import { Box, LinearProgress, Alert, Fab, useMediaQuery, useTheme } from '@mui/material'
import { useFarmId } from '~/common/use-farm-id'
import { useIsSeasonReadOnly } from '~/farm/use-is-season-read-only'
import CropScheduleTimeline from './crop-timeline'
import {
  APPBAR_HEIGHT_REM,
  APPBAR_EXTRA_DESKTOP_REM,
  CONTENT_PADDING_RBL_REM,
  CONTENT_PADDING_T_REM,
  DESKTOP_BREAKPOINT,
} from '~/common/constants/layout-constants'
import { CropModal } from '../crop-modal/crop-modal'
import { Add } from '@mui/icons-material'
import { useFeatures } from '~/common/use-features'

function CropTimelineFullscreen() {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_BREAKPOINT))
  const { farmId, loading } = useFarmId()
  const seasonReadOnly = useIsSeasonReadOnly()
  const [addCropOpen, setAddCropOpen] = useState(false)
  const { features } = useFeatures()

  if (loading) {
    return <LinearProgress />
  }

  if (!farmId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">Please select a farm to view the crop schedule.</Alert>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        height: `calc(100vh - ${APPBAR_HEIGHT_REM} + ${isDesktop ? '0rem' : APPBAR_EXTRA_DESKTOP_REM})`,
        overflow: 'hidden',
        position: 'relative',
        // Remove parent container padding to fill entire screen
        m: `-${CONTENT_PADDING_T_REM} -${CONTENT_PADDING_RBL_REM} -${CONTENT_PADDING_RBL_REM} -${CONTENT_PADDING_RBL_REM}`,
      }}
    >
      <CropScheduleTimeline autoFitZoom fullscreen />

      {features['add_crops'] && !seasonReadOnly && (
        <Fab
          size="small"
          color="primary"
          onClick={() => setAddCropOpen(true)}
          sx={{
            position: 'absolute',
            bottom: 28,
            right: 16,
          }}
        >
          <Add />
        </Fab>
      )}

      <CropModal open={addCropOpen} onClose={() => setAddCropOpen(false)} />
    </Box>
  )
}

export default CropTimelineFullscreen
